import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import { errorMessage, NormalMessage } from "../../utils/alertMessage";
import { formatDate, formatDateWithTime } from "../../constants/FormateDate";
import { getUserLead, getUserLeadSummary } from "../../services/leads";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { replaceUnderscoresWithSpacesAndUpperCase } from "../../components/Regex";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { getUser } from "../../services/userMasterUser";
import { MCubeCall } from "../../services/MCubeCall";

export default function TeleCallerLeadList() {

    const navigate = useNavigate();

    const ds = useRef(null);

    const location = useLocation();
    const isFirstRender = useRef(true);

    const { userProfileData } = getUserData();

    const [products, setProducts] = useState([]);

    let dataLimitValue = localStorage.getItem("dataLimit") || 500;
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(dataLimitValue);
    const [loadingMore, setLoadingMore] = useState(false);

    const statusList = [
        "new leads",
        "today follow ups",
        "in process",
        "call not pick up",
        "not interested",
        "not doable",
        "hold for follow up after sometime",
        "prelogin",
        "login",
        "sanction",
        "disbursement",
        "decline",
        "hold by customer",
    ]

    const statusListFun = () => {
        return statusList.reduce((map, status) => {
            map[status] = {
                count: 0,
                totalAmount: 0,
                leadStatus: status,
            };
            return map;
        }, {});
    };


    const [statusMap, setStatusMap] = useState(statusListFun())

    const [startDate, setStartDate] = useState(new Date(localStorage.getItem("startDateFilter")));
    const [endDate, setEndDate] = useState(new Date(localStorage.getItem("endDateFilter")));

    const [pagesBoxField, setPagesBoxField] = useState(0);
    const [selectedType, setSelectedType] = useState("");
    const [defaultPayload, setDefaultPayload] = useState({})

    const [showTodayFollowup, setShowTodayFollowup] = useState(false);

    const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
  

    const typeData = {
        searchBy: "",
        searchText: "",
        limit: dataLimitValue,
        offset: 0,
        sortBy: "",
        sortOrder: "desc",
        statusIn: [],
        sourceIn: [],
        userIdIn: [userProfileData.id],

        recordType: recordTypeValue,
        startDate: startDate,
        endDate: endDate,
        leadTypeIn: [],
    };



    const fetchData = (data, append = false) => {
        setLoadingMore(true);

        getUserLead(data)
            .then((response) => {
                if (!response.data.error) {

                    const rawData = response.data.data || response.data;
                    setProducts(rawData);
                    setShowTodayFollowup(false);
                } else {
                    errorMessage("Invalid Credentials");
                }
            })
            .catch(() => {
                errorMessage();
            })
            .finally(() => {
                setLoadingMore(false);
            });
    };


    const boxFieldData = {
        leadTypeIn: [],
        recordType: "CreatedOn",
        startDate: startDate,
        endDate: endDate,
      sortBy: "",
      sortOrder: "desc",
        userIdIn: [userProfileData.id],
        statusIn: [
          "in process",
          "call not pick up",
          "not interested",
          "not doable",
          "hold for follow up after sometime",
          "prelogin",
          "login",
          "sanction",
          "disbursement",
          "decline",
          "hold by customer",
        ],

    };

    const todayLeadPayload = {
        leadTypeIn: [],
        recordType: "CreatedOn",
      startDate: startDate,
      endDate: endDate,
      sortBy: "",
      sortOrder: "desc",
      userIdIn: [userProfileData.id],
        statusIn: [
          "ASSIGN",
        ],

    };

    const followUpOnPayload = {
        leadTypeIn: [],
        recordType: "FollowUpOn",
      startDate: startDate,
      endDate: endDate,
      sortBy: "",
      sortOrder: "desc",
      userIdIn: [userProfileData.id],
        statusIn: [
          "in process",
          "call not pick up",
          "not interested",
          "not doable",
          "hold for follow up after sometime",
          "prelogin",
          "login",
          "sanction",
          "disbursement",
          "decline",
          "hold by customer",
        ],

    };

    const fetchBoxFieldData = (data) => {

        getUserLeadSummary(data)
            .then((response) => {
                if (!response.data.error) {

                    const rawData = response.data.data || response.data;
                    rawData.reduce((map, item) => {
                        setStatusMap(prev => ({
                            ...prev,
                            [item.leadStatus]: {
                                ...prev[item.leadStatus],
                                count: item.count,
                                totalAmount: item.totalAmount
                            }
                        }));
                    }, {});


                } else {
                    errorMessage("Invalid Credentials");
                }
            })
            .catch(() => {
                errorMessage();
            })
            .finally(() => {
            });
    };

    const fetchBoxFieldTodayLeadData = (data) => {

        getUserLeadSummary(data)
            .then((response) => {
                if (!response.data.error) {

                    const rawData = response.data.data || response.data;
                    const totalCount = rawData.reduce((sum, item) => sum + (item?.count || 0), 0);
                    const totalAmount = rawData.reduce((sum, item) => sum + (item?.totalAmount || 0), 0);

                    setStatusMap(prev => ({
                        ...prev,
                      ["new leads"]: {
                        ...prev["new leads"],
                            count: totalCount,
                            totalAmount: totalAmount
                        }
                    }));



                } else {
                    errorMessage("Invalid Credentials");
                }
            })
            .catch(() => {
                errorMessage();
            })
            .finally(() => {
            });
    };

    const fetchBoxFieldTodayFollowUpData = (data) => {

        getUserLeadSummary(data)
            .then((response) => {
                if (!response.data.error) {

                    const rawData = response.data.data || response.data;
                    const totalCount = rawData.reduce((sum, item) => sum + (item?.count || 0), 0);
                    const totalAmount = rawData.reduce((sum, item) => sum + (item?.totalAmount || 0), 0);

                    setStatusMap(prev => ({
                        ...prev,
                        ["today follow ups"]: {
                            ...prev["today follow ups"],
                            count: totalCount,
                            totalAmount: totalAmount
                        }
                    }));


                } else {
                    errorMessage("Invalid Credentials");
                }
            })
            .catch(() => {
                errorMessage();
            })
            .finally(() => {
            });
    };

    
    useEffect(() => {
      
      if (location.state?.listState) {
        const { products, first, rows, selectedType, pagesBoxField, statusMap } = location.state.listState;

        setProducts(products);
        setFirst(first);
        setRows(rows);
        setSelectedType(selectedType)
        setPagesBoxField(pagesBoxField)
        setSelectedStatus(selectedType)
        setStatusMap(statusMap)
      } else {
        fetchBoxFieldData(boxFieldData);
        fetchBoxFieldTodayLeadData(todayLeadPayload);
        fetchBoxFieldTodayFollowUpData(followUpOnPayload);
      }
      
    }, []);

    const handleReceiveData = (leadStatus, totalCount, payload) => {
        setSelectedType(leadStatus)
        setPagesBoxField(0);
      setDefaultPayload({
        ...payload,
        statusIn: [leadStatus]
      })
        let pages = Math.ceil(totalCount / dataLimitValue);

        setPagesBoxField(pages);
        if (pages > 0) {
            handlePageChange(0, {
                ...payload,
                statusIn: [leadStatus]
            },)
        }
    };

    const handleReceiveTodayLeadData = (leadStatus, totalCount, payload) => {
        setSelectedType(leadStatus)
        setPagesBoxField(0);
      setDefaultPayload({
        ...payload,
        // statusIn: [leadStatus]
      })
        let pages = Math.ceil(totalCount / dataLimitValue);

        setPagesBoxField(pages);
        if (pages > 0) {
            handlePageChange(0, {
                ...payload,
                // statusIn: statusList
            },)
        }
    };

    const handlePageChange = (pageNumber, defaultPayload) => {
        const newOffset = pageNumber * rows;

        fetchData(
            {
                ...defaultPayload,
                limit: rows,
                offset: newOffset
            },
            true // append mode
        );

        setFirst(newOffset);
    };

    const itemTemplate = (data) => {
        return (
            <div>
            </div>
        )
    }

    const OrderStatusColors = [
        "#3EB3E1",
        "#866CCE",
        "#F5C43A",
        "#09B4AA",
        "#55BD5A",
        "#FF6767",
        "#5D53D8",
        "#6EA4F5",
        "#E89534",
        "#a906c2",
        "#3EB3E1",
        "#866CCE",
        "#F5C43A",
        "#09B4AA",
        "#55BD5A",
        "#FF6767",
        "#5D53D8",
        "#6EA4F5",
        "#E89534",
        "#a906c2",
        "#3EB3E1",
        "#866CCE",
        "#F5C43A",
        "#09B4AA",
        "#55BD5A",
        "#FF6767",
        "#5D53D8",
        "#6EA4F5",
        "#E89534",
        "#a906c2",
        "#3EB3E1",
        "#866CCE",
        "#F5C43A",
        "#09B4AA",
        "#55BD5A",
        "#FF6767",
        "#5D53D8",
        "#6EA4F5",
        "#E89534",
        "#a906c2",
        "#000",
    ];

    function formatIndianShort(value) {
        if (value == null || isNaN(value)) return "";

        const num = Number(value);

        if (num >= 10000000) {
            return (num / 10000000).toFixed(num % 10000000 === 0 ? 0 : 1) + "Cr";
        }

        if (num >= 100000) {
            return (num / 100000).toFixed(num % 100000 === 0 ? 0 : 1) + "L";
        }

        return num.toLocaleString("en-IN");
    }
    // 1. Add this state near your other useState declarations
    const [selectedStatus, setSelectedStatus] = useState(null);

    const handleMcubeCall = (selectedItem) => {

        const data = {
            httpAuthorization: userProfileData?.mcubeAuthToken,
            exeNumber: userProfileData?.mobile,
            custNumber: selectedItem?.lead?.mobileNo
        }

        if (userProfileData?.mcubeAuthToken && userProfileData?.mobile && selectedItem?.lead?.mobileNo) {
            MCubeCall(data)
                .then((response) => {
                    const Res = response.data;
                    // handle the response
                    NormalMessage(Res.msg);
                })
                .catch((error) => {
                    // handle errors
                    errorMessage("Failed");
                });
        } else {
            errorMessage(
                [
                    !userProfileData?.mcubeAuthToken && "Mcube Auth Token Is Not Present",
                    !userProfileData?.mobile && "User Mobile Number Is Not Present",
                    !selectedItem?.lead?.mobileNo && "Customer Mobile Is Not Present",
                ]
                    .filter(Boolean)
                    .join("<br/>")
            );
        }
    }

    return (
        <main id="main" className="main">
            <section className="section main-color">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-main">
                            <div className="card-body">
                                <div
                                    style={{
                                        alignItems: "center",
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <h5 className="card-title flex">
                                        <div
                                            className="mr-3 cursor-pointer"
                                            onClick={() => navigate("/")}
                                        >
                                            <i class="bi bi-arrow-left-circle-fill"></i>
                                        </div> TeleCaller

                                    </h5>
                                     <Link
                                        to="/telecaller-lead-form-create"
                                        className="move-btn move-btn-blue center-text"
                                      >
                                        Create
                                      </Link>
                                </div>

                  <div className="kpi-row-forth">
                                    {selectedStatus && (
                                        <div
                                            className="kpi"
                                            style={{ borderLeftColor: "#999", cursor: "pointer", opacity: 0.7 }}
                                            onClick={() => {
                                                setSelectedStatus(null);
                                                setShowTodayFollowup(false);
                                                setProducts([])
                                                setPagesBoxField(0);
                                            }}
                                        >
                                            <div className="kpi-lbl">✕ Clear filter</div>
                                            <div className="kpi-val">Show all</div>
                                        </div>
                                    )}

                                    {Object.values(statusMap).map((leadItem, index) => (
                                        <div
                                            className="kpi"
                                            style={{
                                                borderLeftColor: OrderStatusColors[index],
                                                cursor: "pointer",
                                                outline: selectedStatus === leadItem.leadStatus
                                                    ? `2px solid ${OrderStatusColors[index]}`
                                                    : "none",
                                                opacity: selectedStatus && selectedStatus !== leadItem.leadStatus ? 0.45 : 1,
                                                transition: "opacity 0.2s, outline 0.2s",
                                            }}
                                            onClick={() => {
                                                if (leadItem.count > 0) {
                                                    setShowTodayFollowup(false);

                                                    if (leadItem.leadStatus === "new leads") {
                                                        handleReceiveTodayLeadData(leadItem.leadStatus, leadItem.count, todayLeadPayload);
                                                    } else if (leadItem.leadStatus === "today follow up") {
                                                        handleReceiveTodayLeadData(leadItem.leadStatus, leadItem.count, followUpOnPayload);
                                                    } else {
                                                        handleReceiveData(leadItem.leadStatus, leadItem.count, typeData);
                                                    }

                                                    setSelectedStatus(prev =>
                                                        prev === leadItem.leadStatus ? null : leadItem.leadStatus
                                                    );
                                                }
                                            }}
                                        >
                                        <div className="kpi-lbl">{leadItem.leadStatus === "hold for follow up after sometime" ? "WIP (More Then 1 Cr)" : leadItem.leadStatus === "in process" ? "WIP (Less Then 1 Cr)" : leadItem.leadStatus} -<span style={{ fontSize: 14, color: "#3b6eef" }}>{leadItem.count}</span></div>
                                            <div className="kpi-val">₹{formatIndianShort(leadItem.totalAmount)}</div>
                                        </div>
                                    ))}
                                </div>


                                <div class="mt-3">
                                     
                                </div>

                                <div className="dataview-demo">
                                    <div className="card leadList">
                                        {pagesBoxField > 0 && <DataTable
                                            value={products}
                                            // lazy
                                            dataKey="id"
                                            scrollable
                                            scrollHeight="400px"
                                            first={first}   // ✅ THIS FIXES YOUR ISSUE
                                            onPage={(e) => setFirst(e.first)} // ✅ also required

                                            paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"

                                            loading={loadingMore}
                                            className="p-datatable-customers client-table-design"
                                            resizableColumns
                                            columnResizeMode="fit"
                                            stripedRows
                                        >
                                              <Column
                                                                     header="#"
                                                                     resizeable={false}
                                                                     className="product-category table-design"
                                                                     body={(data, options) => options.rowIndex + 1}
                                                                   ></Column>
                                                                   <Column
                                                                     field="View"
                                                                     header="View"
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                             
                                                                       <div className="action-cell">
                                                                         <Link
                                                                           title="Edit or View"
                                                                           to="/telecaller-lead-form-create"
                                                                           state={{
                                                                             rowData,
                                                                             listState: {
                                                                               products,
                                                                               first,
                                                                               rows,
                                                                               selectedType,
                                                                               pagesBoxField,
                                                                               statusMap
                                                                             }
                                                                           }}
                                                                           className="act-btn act-view"
                                                                         ><i className="pi pi-pencil"></i>
                                                                         </Link>
                                             
                                                                         <div
                                                                           className="act-btn act-call"
                                                                           onClick={() => {
                                                                             window.location.href = `tel:${rowData?.lead?.mobileNo}`;
                                                                           }}
                                                                         >
                                                                           <i className="pi pi-phone"></i>
                                                                         </div>
                                             
                                                                         <a
                                                                           href={`https://wa.me/91${rowData?.lead?.mobileNo}?text=${encodeURIComponent(
                                                                             `Hello ${rowData?.lead?.name}, thank you for your interest.`
                                                                           )}`}
                                                                           target="_blank"
                                                                           rel="noopener noreferrer"
                                                                           className="act-btn act-whatsapp"
                                                                         >
                                                                           <i className="pi pi-whatsapp"></i>
                                                                         </a>
                                             
                                                                         <div
                                                                           title="Pabbly Lead"
                                                                           className={
                                                                             rowData?.lead?.pabblyResponseMessageId
                                                                               ? "act-btn act-whatsapp"
                                                                               : "act-btn act-red"
                                                                           }
                                                                         >
                                                                           {rowData?.lead?.pabblyResponseMessageId ? (
                                                                             <i className="pi pi-check"></i>
                                                                           ) : (
                                                                             <i className="pi pi-times"></i>
                                                                           )}
                                                                         </div>
                                             
                                                                         <div
                                                                           title="MCube Call"
                                                                           className="act-btn act-call"
                                                                           onClick={() => handleMcubeCall(rowData)}
                                                                         >
                                                                           <i className="bi bi-telephone-outbound-fill"></i>
                                                                         </div>
                                             
                                                                       </div>
                                                                     )}
                                                                   ></Column>
                                                                   <Column
                                                                     field="dateOfLead"
                                                                     header="Date Of Lead"
                                                                     style={{ minWidth: '100px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span className="colored3">
                                                                         {formatDateWithTime(rowData.lead?.dateOfLead)}
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                                                   <Column
                                                                     field="name"
                                                                     header="Name"
                                                                     style={{ minWidth: '100px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span className="colored2">
                                                                         {rowData?.lead?.name}
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                                                   <Column
                                                                     field="mobileNo"
                                                                     header="Mobile No"
                                                                     style={{ minWidth: '120px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span className="colored4">
                                                                         {rowData.lead?.mobileNo}
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                                                   <Column
                                                                     field="typeOfLead"
                                                                     header="Type Of Lead"
                                                                     style={{ minWidth: '100px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span className="colored_with_bg1">
                                                                         {rowData?.lead?.typeOfLead ? replaceUnderscoresWithSpacesAndUpperCase(rowData?.lead?.typeOfLead) : ""}
                                             
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                             
                                             
                                             
                                                                   <Column
                                                                     field="amount"
                                                                     header="Amount"
                                                                     style={{ minWidth: '100px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span className="colored5">
                                                                         {rowData.lead?.amount?.toLocaleString("en-IN")}
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                                                   <Column
                                                                     field="productInfo"
                                                                     header="Product Info"
                                                                     style={{ minWidth: '100px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span className="colored6">
                                                                         {rowData.lead?.productInfo}
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                                                   <Column
                                                                     field="queries"
                                                                     header="Operation Remark"
                                                                     style={{ minWidth: '200px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span>
                                                                         {rowData.lead?.queries}
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                                                   <Column
                                                                     field="address"
                                                                     header="Address"
                                                                     style={{ minWidth: '100px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span>
                                                                         {rowData.lead?.address}
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                                                   <Column
                                                                     field="source"
                                                                     header="Source"
                                                                     style={{ minWidth: '100px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => (
                                                                       <span className="colored7">
                                                                         {rowData.lead?.source}
                                                                       </span>
                                                                     )}
                                                                   ></Column>
                                             
                                                                   <Column
                                                                     field="followUpOn"
                                                                     header="Follow Up On"
                                                                     style={{ minWidth: '100px' }}
                                                                     className="product-category table-design"
                                                                     body={(rowData) => {
                                                                       const followUpDate = rowData?.leadInfoList?.find(
                                                                         item => item.keyName === "nextFollowUpDate"
                                                                       )?.dateValue;
                                             
                                             
                                                                       return (
                                                                         <span>
                                                                           {followUpDate ? formatDate(followUpDate) : "N/A"}
                                                                         </span>
                                                                       );
                                                                     }
                                                                     }
                                                                   ></Column>
                                             
                                             
                                                                   {(userProfileData.role === "ROLE_TELECALLER" || userProfileData.role === "ROLE_SUPER_TELECALLER") &&
                                                                     <Column
                                                                       field="Doc"
                                                                       header="Doc View"
                                                                       className="product-category table-design"
                                                                       body={(rowData) => (
                                                                         <Link
                                                                           to={"/view-lead-document"}
                                                                           state={rowData?.lead}
                                                                           className="move-btn-medium move-btn-green center-text"
                                                                         >
                                                                           Doc View <i className="bi bi-eye"></i>
                                                                         </Link>
                                                                       )}
                                                                     ></Column>}
                                             
                                                                 </DataTable>}
                                        <div className="flex justify-content-center gap-2 my-3">
                                            {Array.from({ length: pagesBoxField }).map((_, index) => (
                                                <Button
                                                    key={index}
                                                    label={(index + 1).toString()}
                                                    onClick={() => handlePageChange(index, defaultPayload)}
                                                    className={rows === index ? "p-button" : "p-button-outlined"}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <DataScroller
                                        ref={ds}
                                        value={products}
                                        itemTemplate={itemTemplate}
                                        rows={5}
                                        loader

                                    />


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
